/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useState, useEffect } from 'react';
import moment from 'moment';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Stack } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Grid from '@mui/material/Unstable_Grid2';
import CloseIcon from '@mui/icons-material/Close';
import CircleIcon from '@mui/icons-material/Circle';

export default function CjeActivityModal({ accountDtls, setAccountDtls }) {
  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const columns = [
    {
      field: 'date_scheduled',
      headerName: 'Appointment Date',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'date_completed',
      headerName: 'Date Completed',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'note',
      headerName: 'Planned Agenda',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'planned',
      headerName: 'Accomplished Agenda',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <div dangerouslySetInnerHTML={{ __html: params.row.planned }} />,
    },
    {
      field: 'note1',
      headerName: 'Activity Details',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
  ];

  const handleClose = () => {
    setAccountDtls({ ...accountDtls, loading: false, toggle: false, title: null, details: [] });
  };
  return (
    <Dialog open={accountDtls?.toggle} onClose={handleClose} maxWidth='xl' fullWidth>
      <DialogTitle>
        {accountDtls?.title}{' '}
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container>
          <Grid item md={12}>
            <Stack alignItems='center' direction='row' gap={2}>
              <CircleIcon sx={{ color: '#6b8d3e' }} />
              Accomplished agenda as planned
              <CircleIcon sx={{ color: '#a82716' }} />
              Different from planned agenda
              <CircleIcon sx={{ color: '#1f46f5' }} />
              Additional Agenda
            </Stack>
          </Grid>
          <Grid item md={12} mt={2}>
            <Box
              className='table-container'
              sx={{
                height: `800px`,
                '& .super-app-theme--header': {
                  fontWeight: 'bold',
                  backgroundColor: '#6B8D3E',
                  color: '#fff',
                },
              }}
            >
              <DataGridPro
                loading={accountDtls.loading}
                rows={accountDtls.details}
                columns={columns}
                sortModel={sortModel}
                initialState={{
                  ...accountDtls.details,
                  pagination: {
                    pageSize: 50,
                  },
                }}
                getRowId={(row) => row.appointment_id}
                rowsPerPageOptions={[25, 50, 100]}
                pagination
                onSortModelChange={(model) => setSortModel(model)}
                getRowClassName={(params) => {
                  return params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row';
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
